import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "./App.scss";

import reportWebVitals from './reportWebVitals';
import CatalogContextProvider from './Context/CatalogContext';
import InsightsContextProvider from './Context/InsightsContext';
import DashboardContextProvider from './Context/DashboardContext';
import { AuthContextProvider } from './Context/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import TokenContextProvider from './Context/TokenContext';
import { GroupReportProvider } from './Context/GroupReportContext';
import { GroupReportDateProvider } from './Context/GroupReportDate';
import AssessmentContextProvider from './Context/AssessmentContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AuthContextProvider>
      <DashboardContextProvider>
        <AssessmentContextProvider>
          <CatalogContextProvider>
            <InsightsContextProvider>
              <TokenContextProvider>
                <GroupReportDateProvider>
                  <GroupReportProvider>
                    <App />
                  </GroupReportProvider>
                </GroupReportDateProvider>
              </TokenContextProvider>
            </InsightsContextProvider>
          </CatalogContextProvider>
        </AssessmentContextProvider>
      </DashboardContextProvider>
    </AuthContextProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
